import { useState, useEffect } from 'react';

import * as Sentry from '@sentry/nextjs';

/**
 * Custom hook to handle global errors
 * @param error Error
 * @returns eventId, layoutData
 */
export const useGlobalErrorHandler = (error: Error) => {
  const [eventId, setEventId] = useState<string>('');

  useEffect(() => {
    const captureException = async () => {
      const id = await Sentry.captureException(error);
      if (id) {
        setEventId(id);
      }
    };

    captureException();
  }, [error]);

  return { eventId };
};
